import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getTipoRequisas = async() => {
    const result = await PrivateInterceptor(`Global/TipoRequisa`, 'GET')
    return result;
}